export default {
  AMPERE: "amp",
  COMPUTED: "cmp"
};
